<template>
  <aside class="col col-4">
    <Calculators v-if="calculators" />
    <Articles v-else-if="articles" />
    <FAQ v-else />
  </aside>
</template>

<script>
import Calculators from './Calculators.vue';
import Articles from './Articles.vue';
import FAQ from './FAQ.vue';

export default {
  components: {
    Calculators,
    Articles,
    FAQ,
  },
  props: {
    calculators: Boolean,
    articles: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.col.col-4 {
  display: flex;
  order: -1;
}
</style>
